// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-spinner {
  --color: var(--smartflip-blue, black);
  width: 50vw;
  height: 50vw;
  max-width: 12rem;
}

.PropertyDetails__SpinnerWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 50vh;
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/views/property-details/property-details.component.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAAJ","sourcesContent":["ion-spinner {\n  --color: var(--smartflip-blue, black);\n  width: 50vw;\n  height: 50vw;\n  max-width: 12rem;\n}\n\n.PropertyDetails {\n  &__SpinnerWrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    min-height: 50vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
